import React, { useCallback, useEffect, useRef, useState } from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'
import { TbReload } from 'react-icons/tb'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  addPanNumber,
  alotnmentDetails,
  checkAllotmentDataList,
  getAllotnment
} from '../../../api/IposApi'
import AllotmentComponent from '../../../components/AllotmentComponent'
import IpoAccordian from '../../../components/IpoAccordian'
import Loader from '../../../components/Loader'

export const AllotnmentDetails = ({ activeTab }) => {
  const dispatch = useDispatch()
  const { ipoDetailData, ipoDetailLoading } = useSelector(
    state => state.ipoDetail
  )
  const [allotnmentDetailsData, setallotnmentDetailsData] = useState([])
  const [error, setError] = useState('')

  const navigate = useNavigate()
  const { id } = useParams()

  const fetch = async () => {
    // setIsLoading(true)
    const subscriptionResponse = await alotnmentDetails(id)
    if (
      subscriptionResponse &&
      subscriptionResponse.meta &&
      subscriptionResponse.meta.status_code === 200
    ) {
      setallotnmentDetailsData(subscriptionResponse?.data)
    }
    // setIsLoading(false)
  }
  const isFirstRun = useRef(true)

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return // Prevents first duplicate call
    }
    fetch()
  }, [error])

  const companyName =
    ipoDetailData?.company_name?.split(' ').slice(0, 2).join(' ') + ' IPO'

  const [data, setData] = useState({})

  const [allotmentStatus, setAllotmentStatus] = useState({})
  const [loadingPan, setLoadingPan] = useState(null)
  const [loading, setLoading] = useState(false)
  const [checkedPans, setCheckedPans] = useState(new Set())
  const [panLoader, setPanLoader] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const handlePageChange = useCallback(
    async ({ selected }) => {
      setLoading(true)
      // try {
      //     const pageNo = selected + 1
      //     await dispatch(
      //         checkAllotmentDataList({ page: pageNo, perPage: 10, navigate, id })
      //     )
      //     setCurrentPage(selected)
      //     setIsPancardLoad(false)
      // } catch (error) {
      //     console.error('Error fetching data:', error)
      // } finally {
      setLoading(false)
      // }
      window.scrollTo(0, 0)
    },
    [dispatch, navigate]
  )

  const checkStatus = async (eve, pan) => {
    if (eve) eve.preventDefault()
    if (loadingPan) return

    setLoadingPan(pan)
    try {
      let response = await getAllotnment({
        pan_number: [pan],
        id: ipoDetailData?.id
      })

      if (response.meta.status_code === 200) {
        setAllotmentStatus(prev => ({
          ...prev,
          [pan]: response?.data[0]?.allotment_status
        }))
      }
    } catch (error) {
      console.error('Error checking allotment:', error)
    }
    setLoadingPan(null)
  }

  useEffect(() => {
    let request = {
      id: ipoDetailData?.id,
      perPage: 10,
      page: currentPage
    }
    checkAllotmentDataList(request).then(response => {
      if (response?.meta?.status_code === 200 || 201) {
        setData(response?.data)
      }
    })
  }, [])

  const loginData = localStorage.getItem('login')
    ? JSON.parse(localStorage.getItem('login'))
    : ''

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
  const [search, setSearch] = useState('')

  const handleSearch = useCallback(eve => {
    setSearch(eve.target.value?.toUpperCase())
  }, [])

  const handleSearchPan = useCallback(
    async eve => {
      eve.preventDefault()
      setPanLoader(true)
      if (!panRegex.test(search)) {
        setError('Invalid PAN format. Example: ABCDE1234F')
        setPanLoader(false)
        return
      }
      setError('')
      if (loginData?.access) {
        try {
          const res = await addPanNumber({ pan_number: search })
          if (res?.meta?.status_code == 200 || res?.meta?.status_code == 201) {
            setSearch('')
            setError('')
            // await checkAllotmentDataList({ page: 1, perPage: 10, navigate, id });
            setCurrentPage(0)
            isFirstRun.current = true
            toast.success(res?.meta?.message)
          } else {
            toast.error(res?.meta?.message)
          }
        } catch (error) {
          console.error(error)
          toast.error('An error occurred while adding PAN number.')
        }
      } else {
        toast.error(
          'You are trying to perform an action that is only available to logged-in users.'
        )
      }
      setPanLoader(false)
    },
    [search, dispatch, navigate, loginData]
  )

  const checkAllPendingPans2 = async () => {
    if (data?.results?.length > 0) {
      const newCheckedPans = new Set()
      for (const ele of data?.results) {
        const latestStatus =
          allotmentStatus[ele.pan_number] || ele.allotment_status
        if (!newCheckedPans.has(ele.pan_number)) {
          setLoadingPan(ele.pan_number)
          await checkStatus(null, ele.pan_number)
          newCheckedPans.add(ele.pan_number)
        }
      }
      setCheckedPans(newCheckedPans)
    }
  }

  console.log('allotnmentDetailsData?.websites', ipoDetailData?.company_address?.Website);

  return (
    <>
      <div className='mainDetailsPage !pt-0 md:!pt-5'>
        <section className='AllotnmentSection mb-8'>
          <div className='mx-auto my-5 md:my-1 md:pb-8'>
            <div className='  border_radius'>
              <form action=''>
                <div className='flex flex-wrap'>
                  <div className='pe-5 flex flex-col'>
                    <label htmlFor='pan' className='label label_pan'>
                      PAN
                    </label>
                    <input
                      type='text'
                      className='w-full input_box mt-2 max_width_input uppercase'
                      value={search}
                      onChange={handleSearch}
                      placeholder='Pan number'
                    />
                    {error && (
                      <p className='text-red-500 text-sm mt-1 error_text'>
                        {error}
                      </p>
                    )}
                  </div>
                  <button
                    className='Check_Allotment mt-5 md:mt-0'
                    type='submit'
                    onClick={handleSearchPan}
                    style={{ marginTop: '30px' }}
                  >
                    <p className='font_semibold'>
                      {panLoader ? 'Adding...' : 'Add PAN Number'}
                      {/* Add PAN Number */}
                    </p>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className=' mx-auto mb-3 '>
            <div className='primary_bg border_radius p-5 md:p-10'>
              <p className='font_medium'>
                {ipoDetailData?.allotment
                  ? `Sometimes, we may encounter technical issues that prevent us from
                                retrieving data. To check your allotment status ,`
                  : `The IPO allotment has not been confirmed yet. To check your status ,`}{' '}
                <span
                  onClick={() => {
                    if (ipoDetailData?.company_address?.Website) {
                      window.open(
                        ipoDetailData?.company_address?.Website,
                        '_blank',
                        'noopener,noreferrer'
                      )
                    }
                  }}
                  target='_blank'
                  className='pleaseClickHere cursor-pointer font-semibold'
                >
                  {companyName} Allotment Status Please Click Here.
                </span>
              </p>
            </div>
          </div>

          <div className=' md:px-5 mx-auto'>
            <div className='flex justify-between md:pb-3 pt-3'>
              <h2 className='common_heading pan_heading mb-3 md:mb-0 '>
                PAN List
              </h2>

              {loginData?.access && ipoDetailData?.allotment && (
                <button
                  className='Check_Allotment max-h-max flex items-center'
                  onClick={() => {
                    checkAllPendingPans2()
                  }}
                >
                  <p className='font_semibold pe-2 max-h-max'>Reload</p>{' '}
                  <TbReload className='max-h-max' />
                </button>
              )}
            </div>
          </div>

          {loading ? (
            <Loader />
          ) : (
            <>
              {loginData?.access ? (
                <>
                  {data?.results?.length > 0 ? (
                    <>
                      {' '}
                      <ul className='alloment_list list-none px-0 flex flex-wrap justify-between'>
                        {data?.results?.map((ele, ind) => {
                          return (
                            <React.Fragment key={ind}>
                              <AllotmentComponent
                                data={{
                                  ...ele,
                                  allotment_status:
                                    allotmentStatus[ele.pan_number] ||
                                    ele.allotment_status,
                                  is_allotment: ipoDetailData?.allotment
                                }}
                                checkStatus={checkStatus}
                                isLoading={loadingPan === ele.pan_number}
                                className={`w-full lg:w-[49%] ${ind > 0 ? 'mt-5' : ''
                                  } ${ind === 1 ? 'lg:mt-0' : ''}`}
                              />
                            </React.Fragment>
                          )
                        })}
                      </ul>
                      {data?.total_page > 1 && (
                        <ReactPaginate
                          previousLabel={<FaChevronLeft />}
                          nextLabel={<FaChevronRight />}
                          breakLabel={'...'}
                          pageCount={data?.total_page}
                          marginPagesDisplayed={5}
                          pageRangeDisplayed={5}
                          onPageChange={handlePageChange}
                          containerClassName={'pagination'}
                          activeClassName={'active'}
                          forcePage={currentPage}
                        />
                      )}
                    </>
                  ) : (
                    <div className='mb-5'>
                      <p className='text-center text-2xl noData mb-5'>
                        No Data Found.
                      </p>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className=' flex flex-wrap justify-center'>
                    <div className='w-full '>
                      <div className='login_section_bg h-full flex items-center justify-center'>
                        <div className='flex flex-col items-center justify-center'>
                          <h2
                            style={{ fontSize: '25px' }}
                            className='login_title text-center'
                          >
                            To access the Quick Allotment Checker, please log in
                            to your account.
                          </h2>

                          <div className='google_btn'>
                            <button
                              class='Check_Allotment min-w-max flex'
                              onClick={() => {
                                navigate('/login')
                              }}
                            >
                              <p class='text-white flex items-center'>
                                {' '}
                                Login{' '}
                              </p>{' '}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </section>

        <section className='content-description mt-5 '>
          <>
            <div className='md:mb-5'>
              <h4>
                The basis of allotment for {ipoDetailData?.company_name} IPO is
                available now.
              </h4>
              <div className='mt-2'>
                <p className='list-none pt-2  pb-2'>
                  To check {ipoDetailData?.company_name} IPO allotment status,
                  follow the steps below :
                </p>
                <ul className='list-decimal ps-7'>
                  <li>Click on the below allotment status check button.</li>
                  <li>Select Company Name.</li>
                  <li>
                    Enter your PAN Number, Application Number or DP Client ID
                    (Anyone).
                  </li>
                  <li>Click on Search.</li>
                </ul>
              </div>
              <p>
                A category of eligible shareholders or other investors who have
                a reserved quota in the IPO.
              </p>
              <p className='mt-2'>
                If you have any concerns or queries about the allotment status,
                contact Kfin Technologies Limited either by phone or email.
                Investors can call on{' '}
                {allotnmentDetailsData?.phone_numbers?.length > 0 &&
                  allotnmentDetailsData?.phone_numbers[0]}{' '}
                or send an email with all relevant details to{' '}
                {allotnmentDetailsData?.emails?.length > 0 &&
                  allotnmentDetailsData?.emails[0]}
                .
              </p>
            </div>

            {/* <div className="flex justify-center pt-5 md:py-10">
                            <Button
                                handleClick={() => {
                                    if (allotnmentDetailsData?.websites?.length > 0) {
                                        window.open(allotnmentDetailsData?.websites[0], "_blank", "noopener,noreferrer");
                                    }
                                }}
                                classList="auth_submit_view_more"
                                content={`${companyName} IPO's Allotment Status`}
                            />
                        </div> */}
          </>
          <h3>{companyName}FAQs</h3>
        </section>
        <div className='my-2 md:mt-4 md:mb-5'>
          <IpoAccordian ipoDetailData={ipoDetailData} />
        </div>
      </div>
    </>
  )
}
